<template>
	<div class="container__crud">
		<div
			class="container__crudactions"
			style="flex-flow: row nowrap"
		>
			<div class="container__crudactions_cruddownload">
				<div class="container__crudactions__cruddownload__crud" />
			</div>
			<MultiSelect
				v-model="fazendasEscolhidas"
				style="padding-right: 20px"
				:label="$t('farm')"
				:options="fazendas"
			/>

			<MultiSelect
				v-model="inventariosEscolhidos"
				style="padding-right: 20px"
				:label="$t('forestInventory')"
				:options="inventarios"
			/>
		</div>

		<Button
			style="margin-left: auto !important; margin-right: 20px !important"
			:label="$t('export')"
			color="trv-default"
			semantic-class="tiny"
			width-auto
			@click="exportar"
		/>
	</div>
</template>

<script>
import Button from '../../../components/Button/Button'
import MultiSelect from '../../../components/MultiSelect/MultiSelect'

import { getDropdown, getEstratoCsv } from '../../../services/requests/ExportacaoRequests.js'

export default {
	components: {
		Button,
		MultiSelect,
	},
	data() {
		return {
			dropdown: [],
			fazendasEscolhidas: [],
			inventariosEscolhidos: [],
		}
	},
	computed: {
		fazendas() {
			return this.dropdown.map((m) => {
				return Object.assign(m, { label: m.fazenda, value: m.fazendaId })
			})
		},
		inventarios() {
			const processamentos = []
			const fazendas = this.dropdown.filter((f) => this.fazendasEscolhidas.includes(f.fazendaId))
			fazendas.forEach((el) => {
				el.processamentos.forEach((elm) => {
					elm.value = elm.estratoInventarioFlorestalId
					elm.label = elm.descricao
					processamentos.push(elm)
				})
			})
			console.log(processamentos)
			return processamentos
			// return .reduce((a, b) => [].concat(a.processamentos).concat(b.processamentos), { processamentos: [] }).map(m => { return Object.assign(m, {label: m.descricao, value: m.estratoInventarioFlorestalId })})
		},
		dadoFormatado() {
			return {
				TipoExportacao: 'Default',
				processamento: this.inventarios.filter((f) =>
					this.inventariosEscolhidos.includes(f.estratoInventarioFlorestalId),
				),
			}
		},
	},
	async created() {
		const response = await getDropdown()
		console.log('🚀 ~ file: InventarioArvore.vue ~ line 59 ~ created ~ response', response)
		this.dropdown = response.data.result
	},
	methods: {
		async exportar() {
			const response = await getEstratoCsv(this.dadoFormatado)
			var a = document.createElement('a')
			a.target = '_blank'
			a.href = response.data.message
			document.body.appendChild(a)
			a.click()
			document.body.removeChild(a)
			console.log('🚀 ~ file: InventarioArvore.vue ~ line 68 ~ export ~ response', response)
		},
	},
}
</script>

<style scoped src="../../../css/crud.css"></style>
